import React from 'react';
import { OrderItem } from 'constants/interface';
import { useBreadcrumbNavigation } from 'hooks/breadcrumb';
import { useRouteMatch } from 'react-router';

import {
  ActionButton,
} from './style';

interface TableRowActionProps {
  orderItem: OrderItem
}

const TableRowAction = ({
  orderItem,
}: TableRowActionProps): JSX.Element => {
  const breadcrumbNavigator = useBreadcrumbNavigation();
  const { url } = useRouteMatch();

  const onDetailsClick = () => {
    breadcrumbNavigator.push({
      label: `Pedido Nº ${orderItem.order.seq}`,
      url: `${url}/${orderItem.order.id}`,
    });
  };

  return (
    <ActionButton
      onClick={() => {
        onDetailsClick();
      }}
    >
      Consultar
    </ActionButton>
  );
};

export default TableRowAction;
